var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10042_13487)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10042_13487)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46489 16.8355C0.986201 14.1207 2.9265 11.5094 5.79866 11.0029L37.0018 5.50098C39.8739 4.99454 42.5903 6.78477 43.069 9.49956L46.536 29.1619C47.0147 31.8767 45.0744 34.488 42.2023 34.9944L10.9992 40.4964C8.12699 41.0028 5.41058 39.2126 4.93189 36.4978L1.46489 16.8355Z",
    fill: "url(#paint0_linear_10042_13487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8631 15.7231C4.7672 15.1792 5.13037 14.6605 5.67426 14.5646L38.4861 8.77901C39.03 8.68311 39.5487 9.04628 39.6446 9.59017L40.9275 16.8661L6.14604 22.999L4.8631 15.7231Z",
    fill: "#E6E5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10042_13487",
    x1: 19.0965,
    y1: 18.494,
    x2: 8.14005,
    y2: 42.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A2A0FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10042_13487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10042_13487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.246,
    height: 42.246,
    fill: "white",
    transform: "translate(-0.469482 5.86523) rotate(-10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.dac6c30f0de7898971d8e58dc43c2884.svg";
export { ForwardRef as ReactComponent };